export default "__VITE_ASSET__C4Q6mPcc__"